import { HeadCell } from 'shell/components/shared/table/types';
import * as yup from 'yup';
import { PersonVM } from 'shell/view-models/search-person';
// import { fiscalCodeRegex } from 'shell/constants/regex';
import { AnprOperation } from 'shell/models/feature';
import { PersonAuthorizationsList } from 'shell/authorizations/person';
import {
  FiltersFormPerson,
  IdentityCardVM,
  ResidencePermitVM,
} from 'shell/view-models/search-anpr';
import { FiltersPersonSearch } from './filters-person-search';

export const validationSchemaFiltersPerson = yup
  .object({
    subjectData: yup.object().shape({
      // fiscalCode: yup.string().nullable().matches(fiscalCodeRegex, 'Codice fiscale non valido.'),
      istatCode: yup.string().nullable().min(6, 'Codice istat è di 6 caratteri'),
      isNationalResearch: yup.boolean().notRequired(),
      municipalityOfResidence: yup
        .object()
        .shape({
          code: yup.string().nullable(),
        })
        .nullable(),
      birthday: yup.date().nullable().typeError('Data non valida'),
      referenceDate: yup.date().nullable().typeError('Data non valida'),
    }),
    identityCard: yup
      .object()
      .shape({
        number: yup
          .string()
          .nullable()
          .matches(/(^\d{7}[a-zA-z]{2}$)|(^[a-zA-z]{2}\d{5}[a-zA-z]{2}$)|(^[a-zA-z]{2}\d{7}$)/gi, {
            message:
              'Numero carta di identità invalido, deve essere in uno di questi formati: AB0000198, CA00001AA o 1111101AB',
          }),
      })
      .test('identityCard', 'Campo obbligatorio', (values) => {
        const castedValues = values as unknown as IdentityCardVM;

        if (castedValues.consulate && castedValues.municipality) {
          return new yup.ValidationError(
            "Valorizzare consolato o carta d'identità",
            undefined,
            'identityCard.municipality'
          );
        }

        if ((castedValues.consulate || castedValues.municipality) && !castedValues.number) {
          return new yup.ValidationError('Campo obbligatorio', undefined, 'identityCard.number');
        }

        return true;
      }),
    residencePermit: yup
      .object()
      .shape({
        permitNumber: yup.string().nullable(),
      })
      .test('residencePermit', 'Campo obbligatorio', (values) => {
        const castedValues = values as unknown as ResidencePermitVM;

        if (castedValues.passportNumber && (castedValues.permitNumber || castedValues.preccint)) {
          return new yup.ValidationError(
            'Valorizzare permesso soggiorno e questura oppure il numero passporto',
            undefined,
            'residencePermit.permitNumber'
          );
        }

        return true;
      }),
  })
  .test('', '', (values) => {
    const castedValues = values as unknown as FiltersFormPerson;

    if (
      castedValues?.openedAccordion === FiltersPersonSearch.FiscalCode &&
      !castedValues?.searchByFiscalCode?.fiscalCode
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'searchByFiscalCode.fiscalCode'
      );
    }

    if (castedValues?.openedAccordion === FiltersPersonSearch.SubjectData) {
      const subjectErrors = [];

      if (
        !castedValues?.subjectData?.name &&
        !castedValues?.subjectData?.withoutName &&
        !(
          (castedValues.subjectData?.municipalityId && castedValues.subjectData?.istatCode) ||
          castedValues.subjectData?.anprId
        )
      ) {
        subjectErrors.push(
          new yup.ValidationError('Campo obbligatorio', undefined, 'subjectData.name')
        );
      }

      if (
        !castedValues?.subjectData?.surname &&
        !castedValues?.subjectData?.withoutSurname &&
        !(
          (castedValues.subjectData?.municipalityId && castedValues.subjectData?.istatCode) ||
          castedValues.subjectData?.anprId
        )
      ) {
        subjectErrors.push(
          new yup.ValidationError('Campo obbligatorio', undefined, 'subjectData.surname')
        );
      }
      return subjectErrors?.length > 0 ? new yup.ValidationError(subjectErrors) : true;
    }

    if (castedValues?.openedAccordion === FiltersPersonSearch.IdentityCard) {
      if (!castedValues?.identityCard?.number) {
        return new yup.ValidationError('Campo obbligatorio', undefined, 'identityCard.number');
      }
    }
    if (castedValues?.openedAccordion === FiltersPersonSearch.ResidencePermit) {
      if (!castedValues?.residencePermit?.permitNumber) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'residencePermit.permitNumber'
        );
      }
    }
    return true;
  });

export const personAuths = Object.freeze({
  anpr: [AnprOperation.ReadOnlyMilan, AnprOperation.ReadOnlyMilanCertificationAnpr],
  ListaOmonimi: ['0'],
});

export const authAnprPerson = Object.freeze({
  read: PersonAuthorizationsList,
});

export const headCells: HeadCell<PersonVM, keyof PersonVM>[] = [
  {
    id: 'fiscalCode',
    label: 'Codice Fiscale',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'gender',
    label: 'Sesso',
  },
  {
    id: 'birthday',
    label: 'Data di nascita',
  },
  {
    id: 'birthplace',
    label: 'Luogo di nascita',
  },
  {
    id: 'residence',
    label: 'Residenza',
  },
  {
    id: 'state',
    label: 'Stato o Indirizzo',
  },
  {
    id: 'anpr',
    label: 'ANPR',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
